//Exam Data - start
export const FETCH_EXAM_DATA_REQUEST = 'FETCH_EXAM_DATA_REQUEST';
export const FETCH_EXAM_DATA_SUCCESS = 'FETCH_EXAM_DATA_SUCCESS';
export const FETCH_EXAM_DATA_FAILURE = 'FETCH_EXAM_DATA_FAILURE';
export const INVALIDATE_EXAM_DATA_CACHE = 'INVALIDATE_EXAM_DATA_CACHE';
export const CLEAR_EXAM_DATA = 'CLEAR_EXAM_DATA';

//Exam Data - end

//Exam Data Dropdown Options - start
export const FETCH_EXAM_DROPDOWN_OPTIONS_REQUEST = 'FETCH_EXAM_DROPDOWN_OPTIONS_REQUEST';
export const FETCH_EXAM_DROPDOWN_OPTIONS_SUCCESS = 'FETCH_EXAM_DROPDOWN_OPTIONS_SUCCESS';
export const FETCH_EXAM_DROPDOWN_OPTIONS_FAILURE = 'FETCH_EXAM_DROPDOWN_OPTIONS_FAILURE';

//Exam Data Dropdown Options - end


// Get Recalculate Data
export const FETCH_RECALCULATE_DATA_REQUEST = 'FETCH_RECALCULATE_DATA_REQUEST';
export const FETCH_RECALCULATE_DATA_SUCCESS = 'FETCH_RECALCULATE_DATA_SUCCESS';
export const FETCH_RECALCULATE_DATA_FAILURE = 'FETCH_RECALCULATE_DATA_FAILURE';

// Exam data record date
export const UPDATE_EXAM_DATA_RECORD_DATE_REQUEST = 'UPDATE_EXAM_DATA_RECORD_DATE';
export const UPDATE_EXAM_DATA_RECORD_DATE_SUCCESS = 'UPDATE_EXAM_DATA_RECORD_DATE_SUCCESS';
export const UPDATE_EXAM_DATA_RECORD_DATE_FAILURE = 'UPDATE_EXAM_DATA_RECORD_DATE_FAILURE';

// Refresh Raw Exam Data
export const REFRESH_RAW_EXAM_DATA_REQUEST = 'REFRESH_RAW_EXAM_DATA_REQUEST';
export const REFRESH_RAW_EXAM_DATA_SUCCESS = 'REFRESH_RAW_EXAM_DATA_SUCCESS';
export const REFRESH_RAW_EXAM_DATA_FAILURE = 'REFRESH_RAW_EXAM_DATA_FAILURE';

// Save Batch Record exam data
export const SAVE_BATCH_RECORD_EXAM_DATA_REQUEST = 'SAVE_BATCH_RECORD_EXAM_DATA_REQUEST';
export const SAVE_BATCH_RECORD_EXAM_DATA_SUCCESS = 'SAVE_BATCH_RECORD_EXAM_DATA_SUCCESS';
export const SAVE_BATCH_RECORD_EXAM_DATA_FAILURE = 'SAVE_BATCH_RECORD_EXAM_DATA_FAILURE';

//Get batch by record date
export const FETCH_EXAM_DATA_BATCH_REQUEST = 'FETCH_EXAM_DATA_BATCH_REQUEST';
export const FETCH_EXAM_DATA_BATCH_SUCCESS = 'FETCH_EXAM_DATA_BATCH_SUCCESS';
export const FETCH_EXAM_DATA_BATCH_FAILURE = 'FETCH_EXAM_DATA_BATCH_FAILURE';

// Save Batch Record

export const SAVE_BATCH_RECORD_REQUEST = 'SAVE_BATCH_RECORD_REQUEST';
export const SAVE_BATCH_RECORD_SUCCESS = 'SAVE_BATCH_RECORD_SUCCESS';
export const SAVE_BATCH_RECORD_FAILURE = 'SAVE_BATCH_RECORD_FAILURE';

// Check Recalculation

export const CHECK_RECALCULATION_REQUEST = 'CHECK_RECALCULATION_REQUEST';
export const CHECK_RECALCULATION_SUCCESS = 'CHECK_RECALCULATION_SUCCESS';
export const CHECK_RECALCULATION_FAILURE = 'CHECK_RECALCULATION_FAILURE';

//Re Calculate Exam Data Details

export const RE_CALCULATE_EXAM_DATA_DETAILS_REQUEST = 'RE_CALCULATE_EXAM_DATA_DETAILS_REQUEST';
export const RE_CALCULATE_EXAM_DATA_DETAILS_SUCCESS = 'RE_CALCULATE_EXAM_DATA_DETAILS_SUCCESS';
export const RE_CALCULATE_EXAM_DATA_DETAILS_FAILURE = 'RE_CALCULATE_EXAM_DATA_DETAILS_FAILURE';
export const RESET_CHECK_RECALCULATION = 'RESET_CHECK_RECALCULATION';

// Get Unassigned Combinations
export const FETCH_UNASSIGNED_COMBINATIONS_REQUEST = 'FETCH_UNASSIGNED_COMBINATIONS_REQUEST';
export const FETCH_UNASSIGNED_COMBINATIONS_SUCCESS = 'FETCH_UNASSIGNED_COMBINATIONS_SUCCESS';
export const FETCH_UNASSIGNED_COMBINATIONS_FAILURE = 'FETCH_UNASSIGNED_COMBINATIONS_FAILURE';

// Check Worklist Assignments
export const CHECK_WORKLIST_ASSIGNMENTS_REQUEST = 'CHECK_WORKLIST_ASSIGNMENTS_REQUEST';
export const CHECK_WORKLIST_ASSIGNMENTS_SUCCESS = 'CHECK_WORKLIST_ASSIGNMENTS_SUCCESS';
export const CHECK_WORKLIST_ASSIGNMENTS_FAILURE = 'CHECK_WORKLIST_ASSIGNMENTS_FAILURE';

// Save Worklist Mapping
export const SAVE_WORKLIST_MAPPING_REQUEST = 'SAVE_WORKLIST_MAPPING_REQUEST';
export const SAVE_WORKLIST_MAPPING_SUCCESS = 'SAVE_WORKLIST_MAPPING_SUCCESS';
export const SAVE_WORKLIST_MAPPING_FAILURE = 'SAVE_WORKLIST_MAPPING_FAILURE';

export const SAVE_WORKLIST_MAPPING_UPDATE_REQUEST = 'SAVE_WORKLIST_MAPPING_UPDATE_REQUEST';
export const SAVE_WORKLIST_MAPPING_UPDATE_SUCCESS = 'SAVE_WORKLIST_MAPPING_UPDATE_SUCCESS';
export const SAVE_WORKLIST_MAPPING_UPDATE_FAILURE = 'SAVE_WORKLIST_MAPPING_UPDATE_FAILURE';

// Get Unassigned Exam Data Count (tab badge)
export const FETCH_UNASSIGNED_EXAM_DATA_COUNT_REQUEST = 'FETCH_UNASSIGNED_EXAM_DATA_COUNT_REQUEST';
export const FETCH_UNASSIGNED_EXAM_DATA_COUNT_SUCCESS = 'FETCH_UNASSIGNED_EXAM_DATA_COUNT_SUCCESS';
export const FETCH_UNASSIGNED_EXAM_DATA_COUNT_FAILURE = 'FETCH_UNASSIGNED_EXAM_DATA_COUNT_FAILURE';

// Export Calculated Exam Data To CSV
export const EXPORT_CALCULATED_EXAM_DATA_REQUEST = 'EXPORT_CALCULATED_EXAM_DATA_REQUEST';
export const EXPORT_CALCULATED_EXAM_DATA_SUCCESS = 'EXPORT_CALCULATED_EXAM_DATA_SUCCESS';
export const EXPORT_CALCULATED_EXAM_DATA_FAILURE = 'EXPORT_CALCULATED_EXAM_DATA_FAILURE';
